import { render } from "./BalBtnGroup.vue?vue&type=template&id=1af6c08b&ts=true"
import script from "./BalBtnGroup.vue?vue&type=script&lang=ts"
export * from "./BalBtnGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__